// Compares a job's imported Templator/LPI field template area to the quoted
// drawn area. Returns null when there's nothing to compare (no template or the
// linked quote has no drawn pieces). `changed` is true when the field ft²
// differs from quoted by more than max(0.5 ft², 2%).
export const templatorDiff = (tpl) => {
  if (!tpl) return null;
  const quoted = Number(tpl.quoted_sqft) || 0;
  const field = Number(tpl.total_sqft) || 0;
  if (quoted <= 0) return null;
  const delta = Math.round((field - quoted) * 100) / 100;
  return {
    quoted,
    field,
    delta,
    changed: Math.abs(delta) > Math.max(0.5, quoted * 0.02),
  };
};
